/**
 * Baixa em segundo plano os chunks das telas mais usadas, para a primeira
 * navegação até elas não esperar rede. Os caminhos precisam ser os mesmos
 * de `AppRoutes` para o webpack reutilizar o chunk.
 */
const COMMON_ROUTE_LOADERS: Array<() => Promise<unknown>> = [
  () => import('../pages/Agenda'),
  () => import('../pages/Inbox/DynamicWhatsAppInbox'),
  () => import('../pages/Clinic/Patients'),
  () => import('../pages/Financial/CashRegister'),
  () => import('../pages/Financial/AccountsReceivable'),
  () => import('../pages/Clinic/Budgets'),
  () => import('../pages/CrmBoard'),
  () => import('../pages/TeamChat/TeamChat'),
];

type IdleWindow = Window & {
  requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => number;
};

function whenIdle(cb: () => void, timeout = 2000) {
  const w = window as IdleWindow;
  if (typeof w.requestIdleCallback === 'function') w.requestIdleCallback(cb, { timeout });
  else window.setTimeout(cb, 400);
}

let started = false;

export function prefetchCommonRoutes(): void {
  if (started || typeof window === 'undefined') return;
  const conn = (navigator as Navigator & { connection?: { saveData?: boolean } }).connection;
  if (conn?.saveData) return;
  started = true;

  const queue = [...COMMON_ROUTE_LOADERS];
  const next = () => {
    const load = queue.shift();
    if (!load) return;
    load().catch(() => undefined).finally(() => whenIdle(next));
  };
  whenIdle(next, 3000);
}
